<template>
  <div className="redirect">
    <div className="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div className="loading">
      <div className="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
import authenService from "../../services/authenService";
import deviceInfoService from "../../services/deviceInfoService";
import userService from "../../services/userService";
import crypto from "crypto";
import VueCookies from "vue-cookies";
import constants from "../../constants";

export default {
  name: "LoginCallback",

  data() {
    return {};
  },

  created() {
    this.storeDeviceInfo();
    this.saveToken();
  },

  methods: {

    /**
     * IdHash :  phục vụ cho việc check quyền download file;
     * @param user
     */
    storeIdHash(user, tokenData) {
      let idHash = crypto
        .createHash("md5")
        .update(user.id + user.userName)
        .digest("hex");
      let hostName = window.location.hostname;
      VueCookies.set("IdHash", idHash, -1, '/', hostName);
      VueCookies.set(constants.HTTP_HEADER_KEY.X_TENANT_CODE, user.tenantCode, -1, '/', hostName);
      VueCookies.set("refreshToken", tokenData["refresh_token"], -1, '/', hostName);
      VueCookies.set("sessionId", tokenData["sessionId"], -1, '/', hostName);
    },
    storeDeviceInfo() {
      deviceInfoService.saveDeviceInfo();
    },
    defaultRouting() {
      if (constants.SMART_OFFICE_USING_SMS) {
        console.log('Có sử dụng sms');
        this.$router.replace({name: "otp"});
      } else {
        console.log('Ko sử dụng sms');
        this.$router.replace({name: "beforeEnterApp"});
      }

    },

    saveToken() {
      let hash = window.location.hash;
      let loginCallbackPrefix = "#/loginCallback";
      hash.startsWith(loginCallbackPrefix) &&
      (hash = hash.substr(
        hash.indexOf(loginCallbackPrefix) + loginCallbackPrefix.length
      ));

      const tokenData = {};

      hash
        .substr(1)
        .split("&")
        .forEach(item => {
          const elements = item.split("=");
          tokenData[decodeURI(elements[0])] = decodeURI(elements[1]);
        });

      //console.log("saveSessionId", tokenData);
      authenService.saveSessionId(tokenData["sessionId"]);

      authenService
        .saveToken(tokenData)
        .then(() => userService.get().then(response => response.data))
        .then(user => this.storeIdHash(user, tokenData))
        .then(() => this.defaultRouting());
    }
  }
};
</script>

<style>
.redirect {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/login/LoginCallback.vue